module.exports = __webpack_public_path__ + "static/media/works.e1384bba.jpg";